import { useEffect, useState } from 'react';
import { tokens } from '../lib/api';

/**
 * Poster aus der geschuetzten API.
 *
 * Ein `<img src="…">` kann keinen Authorization-Header mitschicken; die
 * Bilder bekaemen alle 401. Den Endpunkt dafuer unauthentifiziert zu
 * oeffnen waere der bequeme, aber falsche Weg — also wird das Bild geholt
 * und als Blob-URL eingehaengt. Die URL wird beim Verlassen wieder
 * freigegeben, sonst sammelt eine lange Sitzung sie an.
 */
export function Poster({ id, alt = '', className }: { id: string; alt?: string; className?: string }) {
  const [url, setUrl] = useState<string | null>(null);
  const [weg, setWeg] = useState(false);

  useEffect(() => {
    let abgebrochen = false;
    let objURL: string | null = null;
    (async () => {
      try {
        const r = await fetch(`/api/library/${id}/poster`, {
          headers: tokens.access ? { Authorization: `Bearer ${tokens.access}` } : {},
        });
        if (!r.ok) throw new Error(String(r.status));
        const b = await r.blob();
        if (abgebrochen) return;
        objURL = URL.createObjectURL(b);
        setUrl(objURL);
      } catch {
        if (!abgebrochen) setWeg(true);
      }
    })();
    return () => {
      abgebrochen = true;
      if (objURL) URL.revokeObjectURL(objURL);
    };
  }, [id]);

  if (weg || !url) return <div className="poster__ersatz">{alt.slice(0, 2).toUpperCase() || '–'}</div>;
  // `className` steuert die Groesse. Ohne eine Breitenvorgabe rendert das
  // Bild in seiner natuerlichen Groesse und wird vom Elternkasten links
  // abgeschnitten — genau das sah im Detailfenster so uebel aus.
  return <img src={url} alt={alt} className={className ?? 'poster__img'} loading="lazy" />;
}
